<div
  *ngIf="isWithinTimeframe"
  class="alert-banner"
  [ngClass]="alertClass"
  [attr.data-viewport]="viewport"
  [@fadeAnimation]="isAlertClosed ? 'close' : 'open'"
  role="alert"
>
  <div class="header">
    <div class="header--content">
      <div class="header--content__wrapper">
        <hdi-icon
          class="header--content__wrapper__left-icon"
          [iconName]="headerIcon"
          [iconPrefix]="'far'"
          [size]="iconSize"
          [color]="iconColor"
        ></hdi-icon>
        <h5 *ngIf="isExpandable">{{ title | slice: 0 : 120 }}</h5>
        <hdi-icon
          *ngIf="isExpandable"
          [iconName]="'chevron-down'"
          [ngClass]="isDropdownOpen ? 'flip' : ''"
          [size]="iconSize"
          [color]="iconColor"
          (click)="isExpandable ? toggleDropdown() : null"
        ></hdi-icon>
        <a
          *ngIf="!isExpandable"
          class="header--content__link"
          [href]="href"
          (click)="handleLinkClick($event, href)"
        >
          <h5>{{ title | slice: 0 : 120 }}</h5>
          <hdi-icon
            [iconName]="actionIcon"
            [iconPrefix]="'far'"
            [size]="iconSize"
            [color]="iconColor"
          ></hdi-icon>
        </a>
      </div>
      <div class="close-button" (click)="closeAlert()">
        <hdi-icon
          [iconName]="'close'"
          [iconPrefix]="'far'"
          [size]="iconSize"
          [isHover]="true"
          [color]="iconColor"
        ></hdi-icon>
      </div>
    </div>
  </div>

  <div
    class="dropdown"
    [@dropdownAnimation]="isDropdownOpen ? 'visible' : 'hidden'"
  >
    <div class="dropdown--content">
      <p [innerHTML]="dropdownText"></p>
      <ng-content></ng-content>
      <ng-container *ngIf="link">
        <hdi-link
          [label]="link.label | capitalize"
          [href]="link.href!"
          [hrefType]="link.hrefType ? link.hrefType : HrefType.ANGULAR_ROUTE"
          [title]="link.title ?? ''"
        ></hdi-link>
      </ng-container>
    </div>
  </div>
</div>
